import { Text, TextProps } from "@mantine/core"

export type MissingProps = TextProps & {
  value?: string
}

export const Missing = ({ value, ...textProps }: MissingProps) => {
  return (
    <Text span c="gray" {...textProps}>
      {value ?? "-"}
    </Text>
  )
}
